module.exports = __webpack_public_path__ + "img/Remi Marenco.b1ff3ccd.jpg";